import React from "react";
import thinking from "../Image/thank-you-11918.png";
import { useNavigate } from "react-router-dom";
const FinalPage = () => {
          let navigate = useNavigate();
  const onButtonClick = () => {
          navigate("/");
  };
  return (
    <center>
      <div className="">
        <div className="flex items-center justify-center  ">
          <img
            src={thinking}
            alt=""
            className="w-[300px] md:w-[400px] mt-[104px]"
          />
        </div>
  
        <div className="flex  flex-col items-center justify-center ">
         
          <p
            className="dark:text-white pl-2 pb-2 md:pb-8 text-[20px] md:text-[44px] "
            
          >
            I got your mail..
          </p>
          <button
            onClick={onButtonClick}
            className="py-3 px-14 flex text-lg font-normal dark:text-white  border-[4px] border-[#17A6DB] dark:border-[#30dada] rounded-[48px] shadow-[40px] duration-200  hover:dark:selection:text-white  md:text-3xl"
          >
            Go Back
          </button>
        </div>
      </div>
    </center>
  );
};

export default FinalPage;
